<template>
  <div class="dhr-sideview">
    <button
      v-if="data.image"
      class="btn-image-zoom"
      @click.stop="openFullScreen"
    >
      <BaseIcon name="search-plus" class="icon" />
    </button>
    <h4 class="content-subtitle">Drawing</h4>
    <div v-if="data.image" class="image" @click.stop="openFullScreen">
      <img :src="data.image" alt="" />
    </div>
    <div v-else class="image">
      <span class="no-data">No image found for this device.</span>
    </div>
    <div v-if="isImageOpened" class="fullscreen">
      <div class="imageview" v-click-outside="closeFullScreen">
        <button class="btn-close" @click="closeFullScreen">
          <BaseIcon name="window-close" class="icon" />
        </button>
        <button class="btn-close btn-magnify" @click="trackMe = !trackMe">
          <BaseIcon v-if="trackMe" name="search-plus" class="icon active" />
          <BaseIcon v-else name="search-plus" class="icon" />
        </button>
        <div class="magnifying-glass-container">
          <div v-if="trackMe" id="magnifying-glass">
            <img v-if="trackMe" :src="data.image" class="big-image" />
          </div>
          <img
            v-if="trackMe"
            :src="data.image"
            @mousemove="trackMouse($event)"
          />
          <img v-else :src="data.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon
  },

  props: {
    data: Object
  },
  mounted() {
    this.magnifyingglass = document.getElementById("magnifying-glass");
  },
  data() {
    return {
      isImageOpened: false,
      trackMe: false,
      magnifyingglass: null,
      img: {
        el: null,
        bounds: null
      },
      bigImg: {
        el: null,
        bounds: null
      },
      size: 200
    };
  },
  methods: {
    openFullScreen() {
      this.isImageOpened = true;
    },
    closeFullScreen() {
      this.isImageOpened = false;
    },
    trackMouse(event) {
      if (this.magnifyingglass || this.img.bounds) {
        let top = event.pageY - this.img.bounds.top - this.size / 2;
        let left = event.pageX - this.img.bounds.left - this.size / 2;

        this.magnifyingglass.style.top = top + "px";
        this.magnifyingglass.style.left = left + "px";

        let leftperc = ((left + this.size / 2) / this.img.bounds.width);
        let topperc = ((top + this.size / 2) / this.img.bounds.height);

        let topdiff = (this.bigImg.bounds.height - this.img.bounds.height) / 2;
        let leftdiff = (this.bigImg.bounds.width - this.img.bounds.width) / 2;

        let topbig = -top + topdiff - (topdiff * 2 * topperc);
        let leftbig = -left + leftdiff - (leftdiff * 2 * leftperc);

        this.bigImg.el.style.top = topbig + "px";
        this.bigImg.el.style.left = leftbig + "px";
      } else {
        this.magnifyingglass = document.getElementById("magnifying-glass");
        this.img.bounds = event.toElement.getBoundingClientRect();
        this.bigImg.el = this.magnifyingglass.firstElementChild;
        this.bigImg.bounds = this.bigImg.el.getBoundingClientRect();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$magnifyGlassSize: 200px;
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

.no-data {
  color: #6a6a6a;
  font-style: italic;
  padding-top: 16px;
}

.dhr-sideview .fullscreen .imageview .btn-close.btn-magnify {
  top: calc(24px + 32px + 10px);
}
.magnifying-glass-container {
  max-height: 56vh;
  position: relative;
  overflow: hidden;
  #magnifying-glass {
    content: "";
    position: absolute;
    z-index: 9999;
    border: $magnifyGlassSize / 50 solid red;
    height: $magnifyGlassSize;
    width: $magnifyGlassSize;
    border-radius: $magnifyGlassSize / 2;
    pointer-events: none;
    overflow: hidden;
    top: 0;
    left: 0;
  }
  .big-image {
    max-width: unset;
    margin-top: -$magnifyGlassSize / 50;
    margin-left: -$magnifyGlassSize / 50;
    top: calc(190% - (#{$magnifyGlassSize} / 50));
    left: calc(90% - (#{$magnifyGlassSize} / 50));
    transform: scale(2);
  }
}
</style>
